module.exports = __webpack_public_path__ + "static/site-1784739815621/img/logo_amex.2dc1fd72.svg";